import { z } from 'zod'
import { parseDataOfType } from '@/common/parseDataType'
import { apiErrorHandler } from '../errorHandler'

export const SalesChannel = {
  Stripe: 'Stripe',
  AwsMarketplace: 'AWS_Marketplace',
  Direct: 'Direct',
  Unknown: 'Unknown'
} as const

export type SalesChannel = (typeof SalesChannel)[keyof typeof SalesChannel]

export const UserOrgProfileSchema = z
  .object({
    uid: z.number(),
    first_name: z.string(),
    surname: z.string(),
    email: z.email(),
    sys_admin: z.boolean(),
    email_verified: z.boolean(),
    org: z.object({
      name: z.string(),
      slug: z.string(),
      owner: z.boolean(),
      admin: z.boolean(),
      sales_channel: z.enum(SalesChannel),
      payment_active: z.boolean()
    }),
    enabled_features: z.object({
      search_agent: z.boolean(),
      email_agent: z.boolean(),
      email_agent_dev: z.boolean().optional().default(false),
      script_agent: z.boolean(),
      story_board_agent: z.boolean(),
      search_agent_dev: z.boolean().optional().default(false),
      marketing_agent: z.boolean(),
      marketing_agent_dev: z.boolean().optional().default(false),
      content_connectors: z.boolean(),
      g_drive_connector: z.boolean(),
      sharepoint_connector: z.boolean(),
      webcrawler_connector: z.boolean(),
      connector_resync: z.boolean(),
      global_content: z.boolean()
    })
  })
  .describe('UserOrgProfile')
export type UserOrgProfile = z.infer<typeof UserOrgProfileSchema>

export async function apiUserOrgProfile(): Promise<UserOrgProfile> {
  const res = await fetch(`${window.location.origin}/api/user/profile`, {
    method: 'GET',
    credentials: 'same-origin'
  })
  await apiErrorHandler(res)
  return parseDataOfType(await res.json(), UserOrgProfileSchema)
}

export const UpdateProfileRequestSchema = z
  .object({
    first_name: z.string().min(1, 'First name is required'),
    surname: z.string().min(1, 'Last name is required')
  })
  .describe('UpdateProfileRequest')
export type UpdateProfileRequest = z.infer<typeof UpdateProfileRequestSchema>

export async function apiUpdateProfile(data: UpdateProfileRequest): Promise<void> {
  const req = parseDataOfType(data, UpdateProfileRequestSchema)
  const res = await fetch(`${window.location.origin}/api/user/profile`, {
    method: 'POST',
    credentials: 'same-origin',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(req)
  })
  await apiErrorHandler(res)
}
